// ─────────────────────────────────────────────────────────────────
// Glass-i — Customer Salesperson Mapping API client (Stage HRMS-1).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/hrms/customer-salesperson-mapping';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const hrmsMappingApi = {
  list:     (params = {}) => client.get(BASE, { params }).then(unwrap),
  bulkSave: (items)       => client.post(`${BASE}/bulk-save`, { items }).then(unwrap),
  // Single-customer assignment (additive customer route).
  assign:   (customerId, salespersonEmployeeId) =>
    client.put(`/api/erp/customers/${encodeURIComponent(customerId)}/salesperson`,
      { salespersonEmployeeId: salespersonEmployeeId || null }).then(unwrap)
};

export default hrmsMappingApi;
